import { message } from 'antd';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { searchStoreList, SearchStoreListParams } from 'services/api/store';
import { useInfiniteScroll, useRequest } from 'ahooks';

type Props = Omit<SearchStoreListParams, 'cursor' | 'page_size'>;

const useStoreList = (props: Props, options?: { ready?: boolean; refreshKey?: any }) => {
  const [searchOptions, setSearchOptions] = useState(props);
  const { t } = useTranslate();
  const { runAsync } = useRequest(
    (cursor: number) => {
      return searchStoreList({ ...searchOptions, page_size: 100, cursor });
    },
    { ready: options?.ready, manual: true },
  );
  const { data, loadMore, loading, loadingMore, noMore, mutate } = useInfiniteScroll(
    (data) => {
      return runAsync(data?.next).then((res) => {
        return {
          list: res.data.data.data,
          next: res.data.data.nextCursor,
          hasMore: res.data.data.hasNext,
        };
      });
    },
    {
      reloadDeps: [searchOptions, options?.ready, options?.refreshKey],
      isNoMore: (data) => !data?.hasMore,
      manual: !options?.ready,
      onError() {
        message.error(t('storeSelector.获取店铺列表失败'));
      },
    },
  );

  return {
    storeList: data?.list || [],
    loadMore,
    onChange: setSearchOptions,
    searchOptions,
    loading,
    hasMore: !noMore,
    isLoadingMore: loadingMore,
    setStoreList: mutate,
  };
};

export default useStoreList;
